module.exports = __webpack_public_path__ + "store/img/TagPersonalization.a9adb5d5.svg";